import { useState, useEffect, useRef, useCallback, Fragment, useMemo } from "react";
import style from "./AreaItem.module.scss";
import { v4 } from "uuid";
import * as YStyled from "../../Styleds";
const AreaItem = ({isSelect,data,index,onClick}) => {
    useEffect(() => {
    }, [])
    return (
        <div onClick={e => { onClick(index) }} className={isSelect ? `${style.item} ${style.selected}` : style.item}>
            <img src={isSelect?data.iconSelect:data.icon} />
            <YStyled.Span size={13} fontFamily="SF Pro">{data.label}</YStyled.Span>
        </div>
    );
}

export default AreaItem;